/**
 * Lägenhetsförteckning — a clean, attachable bilaga (ADR-0061).
 *
 * Legacy status is `draft` (scaffold for the framställan apartment-list
 * test). The parent avtal references it as "Se Bilaga N"; it carries no
 * signing of its own.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
import { declaredSectionInstances } from '../common/custom-sections.js';
const DEFAULT_TITLE = 'Lägenhetsförteckning';
export const lagenhetsforteckningV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'lagenhetsforteckning',
    documentVersion: 'v1',
    title: typeof values.document_title === 'string' && values.document_title.trim() !== ''
        ? values.document_title.trim()
        : DEFAULT_TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Övriga avtal',
        shortTitle: 'Lägenhetsförteckning',
        numberStyle: 'paragraph',
        description: 'En bilaga med en horisontell lägenhetsförteckning. Bifogas valfritt avtal ' +
            'och har ingen egen signering — den följer med det signerade avtalet.',
        status: 'draft',
        attachableTo: ['*'],
        titleFromValueKey: 'document_title',
        partySlots: [],
    },
    values,
    blocks: [
        {
            instanceId: 'letterhead',
            blockRef: 'clean_bilaga.letterhead@v1',
            slot: 'letterhead',
            input: { default_title: DEFAULT_TITLE },
        },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: {} },
        ...declaredSectionInstances([{ ref: 'lagenheter', blockRef: 'lagenhetsforteckning.lagenheter@v1' }], {
            customBlockRef: 'clean_bilaga.custom-sections@v1',
        }),
    ],
});
//# sourceMappingURL=lagenhetsforteckning.js.map